export const applicationId = '5a9af8cd-2890-4637-b4f2-70641a759a9b';
export const UNO_URL = 'https://api.simulanis.io';
// export const UNO_URL = 'https://10.90.38.98:3003';
// export const UNO_URL = 'https://abmcpl-ar-vr-appsvcbackend.azurewebsites.net';
// export const UNO_URL = 'http://localhost:3003';
// export const UNO_URL = 'https://simulanis-uno-backend-backup-uat.azurewebsites.net';
export const SECRET_KEY = "uxbA5VlmZ=dcdzMk^%gIw?&N<}P"